import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const columns = [
  {
    title: 'Explore',
    links: [
      { label: 'About us', to: '/about' },
      { label: 'Narsimha', to: '/narsimha' },
      { label: 'Defence', to: '/defence' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Research', to: '/research' },
      { label: 'Investor', to: '/investor' },
      { label: 'Blog', to: '/blog' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact us', to: '/contact' },
      { label: 'Parts, Gear & Accessories', to: '/accessories' },
      { label: 'Book Test Ride', to: '/test-ride' },
    ],
  },
];

const socials = [
  { label: 'LinkedIn', url: 'https://www.linkedin.com/company/acriolisindiamotors', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
    </svg>
  ) },
  { label: 'Instagram', url: 'https://www.instagram.com/acriolis_motors/', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  ) },
  { label: 'Facebook', url: 'https://www.facebook.com/AIM.Machines/', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M14 9h2.5V6H14c-2 0-3.5 1.5-3.5 3.5V11H8v3h2.5v7h3v-7H16l.5-3h-3V9.8c0-.5.4-.8 1-.8Z" />
    </svg>
  ) },
  { label: 'WhatsApp', url: 'https://wa.me/919958253628', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 0 0 1.333 4.982L2 22l5.202-1.364a9.92 9.92 0 0 0 4.81 1.233h.005c5.502 0 9.99-4.479 9.99-9.988C22.007 6.478 17.518 2 12.012 2zm5.83 14.156c-.244.688-1.427 1.309-1.959 1.393-.483.076-1.11.11-2.904-.63-2.316-.957-3.792-3.32-3.908-3.473-.116-.153-.948-1.261-.948-2.408 0-1.147.598-1.71.81-1.942.212-.232.463-.29.617-.29.155 0 .309.001.444.007.14.007.33-.053.514.394.19.462.647 1.579.704 1.695.058.117.097.252.019.406-.077.155-.116.252-.232.387-.116.135-.245.3-.348.406-.107.108-.22.22-.094.437.126.216.559.92 1.203 1.493.828.736 1.524.964 1.74.1.216-.107.463-.387.579-.542.116-.155.232-.116.348-.077.116.04.734.346.85.405.116.058.193.087.241.164.049.078.049.447-.193 1.135z"/>
    </svg>
  ) },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Acriolis" className="footer__logo-img" />
            <span>ACRIOLIS</span>
          </Link>
          <p className="footer__tagline">
            Engineered for terrain.<br />
            Built for every adventure.
          </p>
          <div className="footer__socials">
            {socials.map((s) => (
              <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="footer__social">
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer__links">
          {columns.map((col) => (
            <div className="footer__col" key={col.title}>
              <h4 className="footer__col-title">{col.title}</h4>
              <ul className="footer__col-list">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="footer__col-link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-left">
          <span className="footer__copy">© 2026 Acriolis. All rights reserved.</span>
          <div className="footer__legal">
            <Link to="/privacy-policy" className="footer__legal-link">Privacy Policy</Link>
          </div>
        </div>
        <div className="footer__celebration">
          <span className="footer__celebration-text">Proudly Celebrating 80 Years of India's Independence</span>
          <span className="footer__celebration-flag">🇮🇳</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
